import { useState, useEffect } from "react";

// react-router components
import { useLocation } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @material-ui core components
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";

// Vision UI Dashboard PRO React components
import VuiBox from "components/VuiBox";

// Vision UI Dashboard PRO React example components
import { AppBreadcrumbs } from "components/breadcrumbs.component";
import NotificationItem from "examples/Items/NotificationItem";

// Custom styles for DashboardNavbar
import {
  navbar,
  navbarContainer,
  navbarIconButton,
} from "examples/Navbars/DashboardNavbar/styles";

// Vision UI Dashboard PRO React context
import {
  useVisionUIController,
  setTransparentNavbar,
  setMiniSidenav,
} from "context";

// Images
import team2 from "assets/images/team-2.jpg";
import VuiAvatar from "./VuiAvatar";
import { IoLogOut, IoNotifications } from "react-icons/io5";
import VuiTypography from "./VuiTypography";
import { getUser } from "services/auth/auth.service";
import { logout } from "services/auth/auth.service";
import { sidenavData } from "services/constants";

export function AppTopbar({ absolute, light }) {
  const [navbarType, setNavbarType] = useState();
  const [controller, dispatch] = useVisionUIController();
  const { miniSidenav, transparentNavbar, fixedNavbar } = controller;
  const [openMenu, setOpenMenu] = useState(false);
  const route = useLocation().pathname.split("/").slice(1);
  const user = getUser();

  useEffect(() => {
    setNavbarType("static");

    // A function that sets the transparent state of the navbar.
    function handleTransparentNavbar() {
      setTransparentNavbar(dispatch, (fixedNavbar && window.scrollY === 0) || !fixedNavbar);
    }

    /** 
     The event listener that's calling the handleTransparentNavbar function when 
     scrolling the window.
    */
    window.addEventListener("scroll", handleTransparentNavbar);

    // Call the handleTransparentNavbar function to set the state with the initial value.
    handleTransparentNavbar();

    // Remove event listener on cleanup
    return () => window.removeEventListener("scroll", handleTransparentNavbar);
  }, [dispatch, fixedNavbar]);

  const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);
  const handleCloseMenu = () => setOpenMenu(false);
  const getPageTitle = () => {
    return sidenavData.find(item => item.key === route[route.length - 1]).name;
  };
  const getPageBreadcrumb = () => {
    return sidenavData.find(item => item.key === route[route.length - 1]).breadcrumb;
  };

  const handleLogout = () => {
    logout();
  };

  // ACTIVAR CON NOTIFICACIONES
  /* const renderMenu = () => (
    <Menu
      anchorEl={openMenu}
      anchorReference={null}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={Boolean(openMenu)}
      onClose={handleCloseMenu}
      sx={{ mt: 2 }}
    >
      <NotificationItem
        image={<img src={team2} alt="person" />}
        title={["New message", "from Laur"]}
        date="13 minutes ago"
        onClick={handleCloseMenu}
      />
    </Menu>
  ); */

  return (
    <AppBar
      position={absolute ? "absolute" : navbarType}
      color="inherit"
      sx={(theme) => navbar(theme, { transparentNavbar, absolute, light })}
    >
      <Toolbar
        sx={(theme) => navbarContainer(theme)}
      >
        <VuiBox color="inherit" mb={{ xs: 1, md: 0 }}
          sx={() => ({
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            maxWidth: "100%",
          })}
        >
          <AppBreadcrumbs
            icon="home"
            title={getPageTitle()}
            breadcrumb={getPageBreadcrumb()}
            route={route}
            light={true}
            handleMiniSidenav={handleMiniSidenav}
            miniSidenav={miniSidenav}
          />
          <VuiBox
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            {/* ACTIVAR CAMPANA CON NOTIFICACIOENS*/}
            {/* <VuiBox color={light ? "white" : "inherit"}>
              <IconButton
                size="small"
                color="white"
                sx={navbarIconButton}
                aria-controls="notification-menu"
                aria-haspopup="true"
                variant="contained"
                onClick={handleOpenMenu}
              >
                <IoNotifications />
              </IconButton>
              {renderMenu()}
            </VuiBox> */}
            <VuiBox color={light ? "white" : "inherit"}>
              <IconButton
                size="small"
                color="white"
                sx={navbarIconButton}
                aria-controls="notification-menu"
                aria-haspopup="true"
                variant="contained"
                onClick={handleLogout}
              >
                <IoLogOut />
              </IconButton>
            </VuiBox>
            <VuiAvatar bgColor="info" size="sm">
              <VuiTypography color="white" sx={{ fontWeight: "700" }}>{user.firstName[0]}</VuiTypography>
            </VuiAvatar>
          </VuiBox>
        </VuiBox>
      </Toolbar>
    </AppBar>
  );
}

// Setting default values for the props of AppTopbar
AppTopbar.defaultProps = {
  absolute: false,
  light: false,
  isMini: false,
};

// Typechecking props for the AppTopbar
AppTopbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
};
